import { render, staticRenderFns } from "./ListPolicyRenewal.vue?vue&type=template&id=8bb6a68e&scoped=true"
import script from "./ListPolicyRenewal.vue?vue&type=script&lang=js"
export * from "./ListPolicyRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb6a68e",
  null
  
)

export default component.exports